<div class="auth-password-field">
  <div class="auth-password-field__container" [class.auth-password-field__container--error]="showContainerError">
    <img
      src="assets/icons/lock.svg"
      alt=""
      class="auth-password-field__icon"
      aria-hidden="true"
    />
    <input
      [type]="isPasswordVisible ? 'text' : 'password'"
      class="auth-password-field__input"
      [placeholder]="placeholder"
      [formControl]="control"
      [attr.autocomplete]="autocomplete"
    />
    <img
      class="auth-password-field__toggle"
      [src]="isPasswordVisible ? 'assets/icons/eye-open.svg' : 'assets/icons/eye-closed.svg'"
      alt=""
      role="button"
      tabindex="0"
      (click)="toggleVisibility()"
      (keydown.enter)="toggleVisibility()"
      (keydown.space)="$event.preventDefault(); toggleVisibility()"
    />
  </div>
  <div *ngIf="showHint" class="auth-password-field__hint">
    {{ invalidHint }}
  </div>
</div>
